/**
 * @商品相关
 * 2022-08-03 kadiam
*/
// import bossApi from '../utils/bossApi'
import bossWholesale from '../utils/wholesaleRequest'
// import bossXypq from '../utils/bossXypq'

// 商城首页 营销模块列表
export function apiWholesaleSaleModule_list(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleSaleModule/list', method: 'POST', data })
}
// 商城首页 营销模块列表
export function apiWholesaleSaleModule_imageList(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleSaleModule/imageList', method: 'POST', data })
}

// 商品搜索 热门搜索
export function mallProduct_hotSearch() {
  return bossWholesale({ url: 'wholesale/api/user/wholesaleSearch/hotSearchList', method: 'GET' })
}
// 商品列表
export function apiWholesaleProduct_productList(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleProduct/productList', method: 'POST', data })
}
// 推荐商品列表
export function apiWholesaleProduct_productRecommendList(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleProduct/productRecommendList', method: 'POST', data })
}
// 商品详情
export function apiWholesaleProduct_productDetail(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleProduct/productDetail?productId=' + data, method: 'GET' })
}
// 商品询价-新增商品询价表
export function wholesale_queryPrice_save(data) {
  return bossWholesale({ url: 'wholesale/api/wholesale/queryPrice/save', method: 'POST', data })
}
// 阶梯价格
export function wholesale_productPrice(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleProduct/productPrice', method: 'POST', data })
}
/**
 * @商品分类
 * 2022-08-12 kadiam
*/
// 通过id查询下级分类查询
export function apiWholesaleProduct_categoryList(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleProduct/categoryList', method: 'POST', data })
}
// 通过id查询下级分类查询
export function categoryTreeList(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleProduct/categoryTreeList', method: 'POST', data })
}

/**
 * @商品标签搜索
 * 2023-01-17 kadiam
*/
// 商品搜索标签列表
export function searchTagList(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleProduct/searchTagList', method: 'POST', data })
}
// 商品搜索标签 标签分类-子分类查询
export function tagCategoryList(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleProduct/tagCategoryList', method: 'POST', data })
}
/**
 * @专题活动
 * 2024-06-13 kadiam
*/
// 模块详情查询
export function productModule_detail(data) {
  return bossWholesale({ url: 'wholesale/api/productModule/detail', method: 'POST', data })
}
// 购物车商品计算
export function wholesalePreferential_cartCalculate(data) {
  return bossWholesale({ url: 'wholesale/api/wholesalePreferential/cartCalculate', method: 'POST', data })
}
// 商品列表
export function wholesalePreferential_productList(data) {
  return bossWholesale({ url: 'wholesale/api/wholesalePreferential/productList', method: 'POST', data })
}
// 添加购物车
export function wholesalePreferential_addCart(data) {
  return bossWholesale({ url: 'wholesale/api/wholesalePreferential/addCart', method: 'POST', data })
}
// 删除购物车
export function wholesalePreferential_delCart(data) {
  return bossWholesale({ url: 'wholesale/api/wholesalePreferential/delCart', method: 'POST', data })
}
// 商品详情
export function wholesalePreferential_productDetail(data) {
  return bossWholesale({ url: 'wholesale/api/wholesalePreferential/productDetail?productId=' + data, method: 'GET' })
}
// 商品分类品牌查询
export function searchMallProductCategoryBrand(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleProduct/categoryBrand', method: 'POST', data })
}
// 商品分类品牌查询 代理
export function searchMallProductCategoryBrandAgency(data) {
  return bossWholesale({ url: 'wholesale/api/apiWholesaleAgentCart/categorySelection', method: 'POST', data })
}
// 优惠券可用商品品牌查询
export function couponProductBrand(data) {
  return bossWholesale({ url: 'wholesale/api/wholesaleCouponUser/couponProductBrand', method: 'POST', data })
}
// 优惠券可用商品分类查询
export function couponProductCategory(data) {
  return bossWholesale({ url: 'wholesale/api/wholesaleCouponUser/couponProductCategory', method: 'POST', data })
}
